import { getLocalizedMessage } from "@pimo/pimo-l10n";
import { Configuration, PROJECT_NAMES } from "product-test-types";

import { TestAppState } from "../app";

type ProjectName = Exclude<Configuration["projectName"], undefined>;

export function getProjectName(projectName?: ProjectName, language = "en") {
  if (!projectName) {
    return getLocalizedMessage(language, "project") || "Project";
  }

  const found = PROJECT_NAMES.find(({ single }) => single === projectName);

  return (
    getLocalizedMessage(language, `projectNames.${found?.single}`) ||
    getLocalizedMessage(language, "project") ||
    "Project"
  );
}

export function getProjectNameFromState(appState: TestAppState) {
  const language = appState.language || "en";
  const projectName = appState.settings?.configuration?.projectName;

  return getProjectName(projectName, language);
}

export function getPluralOfProjectName(
  projectName?: ProjectName,
  language = "en"
) {
  if (!projectName) {
    return getLocalizedMessage(language, "projects") || "Projects";
  }

  const found = PROJECT_NAMES.find(({ single }) => single === projectName);

  return (
    getLocalizedMessage(language, `projectNames.${found?.plural}`) ||
    getLocalizedMessage(language, "projects") ||
    "Projects"
  );
}

export function getPluralOfProjectNameFromState(appState: TestAppState) {
  const language = appState.language || "en";
  const projectName = appState.settings?.configuration?.projectName;

  return getPluralOfProjectName(projectName, language);
}
